import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des templates RAG d'articles
 */
const articleRagActionsConfig = {
  entityName: 'article_rag_actions',
  apiEndpoint: '/api/config/tool/article-rag-actions',
  exportFileName: 'article-rag-actions',
  
  translations: {
    title: 'ARTICLE_RAG_ACTIONS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { 
      key: 'works_on', 
      label: 'EntityClass', 
      labelKey: 'TABLE_WORKS_ON'
    },
    { 
      key: 'ia_language', 
      label: 'Langue', 
      labelKey: 'TABLE_LANGUAGE'
    },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    },
    { key: 'created_at', label: 'Créé', labelKey: 'TABLE_CREATED_AT' },
    { key: 'updated_at', label: 'Modifié', labelKey: 'TABLE_UPDATED_AT' }
  ],
  
  formFields: [
    {
      name: 'works_on',
      label: 'Type d\'article (EntityClass)',
      labelKey: 'FORM_WORKS_ON',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'works_on',
      placeholder: 'Character, Location, etc...',
      fallbackOptions: [
        { value: 'Character', label: 'Character' },
        { value: 'Location', label: 'Location' },
        { value: 'Item', label: 'Item' },
        { value: 'Organization', label: 'Organization' }
      ]
    },
    {
      name: 'ia_language',
      label: 'Langue',
      labelKey: 'FORM_IA_LANGUAGE',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'ia_language',
      fallbackOptions: [
        { value: 'FR', label: 'Français' },
        { value: 'EN', label: 'English' }
      ]
    },
    {
      name: 'to_title',
      label: 'Template pour le titre',
      labelKey: 'FORM_TO_TITLE',
      type: 'textarea',
      placeholder: 'Template Handlebars pour extraire/générer le titre...'
    },
    {
      name: 'to_context',
      label: 'Template pour le contexte',
      labelKey: 'FORM_TO_CONTEXT',
      type: 'textarea',
      placeholder: 'Template Handlebars pour extraire le contexte pour l\'indexation...'
    },
    {
      name: 'to_content',
      label: 'Template pour le contenu',
      labelKey: 'FORM_TO_CONTENT',
      type: 'textarea',
      placeholder: 'Template Handlebars pour générer le contenu indexable...'
    },
    {
      name: 'to_canon',
      label: 'Template pour les données canon',
      labelKey: 'FORM_TO_CANON',
      type: 'textarea',
      placeholder: 'Template Handlebars pour générer les données canon...'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'FORM_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'works_on',
      label: 'Type d\'article',
      labelKey: 'FILTER_WORKS_ON',
      type: 'dynamic-select',
      dynamicSource: 'works_on',
      fallbackOptions: [
        { value: 'Character', label: 'Character' },
        { value: 'Location', label: 'Location' },
        { value: 'Item', label: 'Item' },
        { value: 'Organization', label: 'Organization' }
      ]
    },
    {
      name: 'ia_language',
      label: 'Langue',
      labelKey: 'FILTER_IA_LANGUAGE',
      type: 'dynamic-select',
      dynamicSource: 'ia_language',
      fallbackOptions: [
        { value: 'FR', label: 'Français' },
        { value: 'EN', label: 'English' }
      ]
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    works_on: '',
    ia_language: 'FR',
    to_title: '',
    to_context: '',
    to_content: '',
    to_canon: '',
    is_active: true
  }
};

/**
 * Composant d'administration des templates RAG d'articles
 */
export function AdminArticleRagActionsTab() {
  return (
    <div className="tab-pane">
      <AdminDataTable {...articleRagActionsConfig} />
    </div>
  );
}

export default AdminArticleRagActionsTab;
